import React, { useState } from 'react';
import { IoArrowForward } from 'react-icons/io5';
import './contact_button.css';
import { scrollToSectionUtils } from '../../../utils/scroll_to_section_ultils.jsx';

const ContactButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        scrollToSectionUtils('contato');
    };

    return (
        <div
            className={`contact-button visible ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
        >
            <span className="contact-text">Entrar em contato</span>
            <div className="arrow-icon">
                <IoArrowForward />
            </div>
        </div>
    );
};

export default ContactButton;
